import { UserRole } from '@shared/models';
import { ROUTES } from '@app/routes/routesUrls';
import ScenesIcon from '@resources/icons/ScenesIcon';
import AiPhotoIcon from '@resources/icons/AiPhotoIcon';
import LifestyleRenderingIcon from '@resources/icons/LifestyleRenderingIcon';
import AISiloIcon from '@resources/icons/AISiloIcon';
import AILifestyleIcon from '@resources/icons/AILifestyleIcon';
import AIVideoIcon from '@resources/icons/AIVideoIcon';
import AIDescriptionIcon from '@resources/icons/AIDescriptionIcon';
import AILightRenderIcon from '@resources/icons/AILightRenderIcon';
import AIServerRenderIcon from '@resources/icons/AIServerRenderIcon';

/* eslint-disable import/prefer-default-export */
export const ObjectType = {
  Light: 'light',
  Model: 'model',
};

export const EntityTypes = {
  Model: 'Model',
  Product: 'Product',
  Interior: 'Interior', // scene model
  Background: 'Background', // interior model
  Material: 'Material',
};

export const HttpStatusCode = {
  Success: 200,
  NotAuthorized: 401,
  NotFound: 404,
};

export const WireframeMaterialName = '__ZolakWireframe__';
export const DefaultMaterialName = '__ZolakMaterial__';

export const defaultTheme = {
  color1: '#00C98F', //Green
  color1Hover: '#05DB9D', //Lightgreen
  color2: '#FFFFFF', // White
  color2Hover: '#FFFFFF', // White
  color3: '#102035', //Dark, usually for texts
  color3Hover: '#00C98F', //Green
  color4: '#334D6E', // Another dark
  color4Hover: '#00C98F', // Green
  fontFamily: 'Poppins, sans-serif',
};

export const defaultUser = {
  company: '',
  email: '',
  role: UserRole.COLLABORATOR,
};

export const defaultScene = {
  name: '',
  url: '',
  interiors: null,
  models: [],
  lights: [],
  allModelsLocked: true,
  env: null,
  envIntensity: 1,
  envRotation: 0,
  softShadows: false,
  samples: 20,
  size: 20,
  focus: 0,
  attributes: [],
  shadowOpacity: 0.2,
  translatedFields: [],
  globalLight: {
    type: 'ambientLight',
    color: '#ffffff',
    intensity: 1,
  },
};
/* eslint-disable max-len */
export const navRoutes = [
  {
    name: '3D Virtual Photography',
    introName: '3D Virtual Photography',
    path: ROUTES.STUDIO.ROOT,
    icon: <ScenesIcon />,
    image: '../assets/images/3d-virtual-photography.png',
    description: 'Upload or select a 3D model of the product and let the system automatically render set of the Silo images from various angles.',
  },
  /*   {
    name: 'AI Product Photography',
    path: ROUTES.AI_PRODUCT.ROOT,
    icon: <AiPhotoIcon />,
  }, */
  {
    name: '3D Lifestyle Rendering',
    icon: <LifestyleRenderingIcon />,
    subItems: [
      {
        name: 'Light (AI Powered)',
        introName: '3D Lifestyle Rendering (Light)',
        path: '/ai-render',
        icon: <AILightRenderIcon />,
        image: '../assets/images/3d-lifestyle-rendering.png',
        description: 'Upload or select a 3D model of the produc to create professional lifestyle images in a tailored setting, with complete control over the environment parameters.',
        disabled: true,
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
      {
        name: 'Server Rendering',
        introName: '3D Lifestyle Server Rendering (Pro)',
        path: '/server-render',
        icon: <AIServerRenderIcon />,
        image: '../assets/images/3d-lifestyle-server-rendering.png',
        description: 'Boost the quality and photorealism of your product lifestyle images with ZOLAK’s high-end server-side rendering approach.',
        disabled: true,
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
    ],
  },
  {
    name: 'AI Product Photography',
    icon: <AiPhotoIcon />,
    subItems: [
      {
        name: 'AI Silo Shots',
        introName: 'AI Product Photography',
        path: ROUTES.SILO.ROOT,
        icon: <AISiloIcon />,
        image: '../assets/images/ai-product-photo.png',
        description: 'Upload a product image to generate a professional-looking product photo with a clean, consistent background.',
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
      {
        name: 'AI Lifestyle Images',
        introName: 'AI Lifestyle Creation',
        path: ROUTES.LIFESTYLE.ROOT,
        icon: <AILifestyleIcon />,
        image: '../assets/images/ai-lifestyle-images.png',
        description: 'Upload a product image to create lifestyle images that showcase your product in context.',
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
      {
        name: 'AI Videos',
        path: ROUTES.VIDEO.ROOT,
        icon: <AIVideoIcon />,
        image: '../assets/images/ai-product-photo.png',
        description: 'Upload a product image to generate a professional-looking product photo with a clean, consistent background.',
        disabled: true,
        visible: false,
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
      {
        name: 'AI Product Descriptions',
        introName: 'AI Product Description Generation',
        path: ROUTES.DESCRIPTION.ROOT,
        icon: <AIDescriptionIcon />,
        image: '../assets/images/ai-desctiption.png',
        description: 'Automatically generate SEO optimized product description base on photo/image.',
        //roles: [UserRole.ADMIN, UserRole.MANAGER],
      },
    ],
  },
];
